import { apiFetch } from './client';

export const listLyrics = (token) => apiFetch(token, '/lyrics');

export const createLyrics = (token, formData) =>
  apiFetch(token, '/lyrics', { method: 'POST', body: formData });

export const updateLyrics = (token, lyricsId, payload) =>
  apiFetch(token, `/lyrics/${lyricsId}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const deleteLyrics = (token, lyricsId) =>
  apiFetch(token, `/lyrics/${lyricsId}`, { method: 'DELETE' });

export const uploadLyricsTunePdf = (token, lyricsId, formData) =>
  apiFetch(token, `/lyrics/${lyricsId}/tune-pdf`, { method: 'POST', body: formData });

export const deleteLyricsTunePdf = (token, lyricsId) =>
  apiFetch(token, `/lyrics/${lyricsId}/tune-pdf`, { method: 'DELETE' });

export const bulkUploadTunePdfs = (token, formData) =>
  apiFetch(token, '/lyrics/tune-pdfs/bulk', { method: 'POST', body: formData });

export const spellcheckLyrics = (token, payload) =>
  apiFetch(token, '/lyrics/spellcheck', { method: 'POST', body: JSON.stringify(payload) });
